import React from "react";

import { Permission } from "@/jenesys-types/jenesys-entities/permissions";

import { useRoles } from "@/hooks/util/useRoles";

interface Props {
  children: React.ReactNode;
  when: Permission;
  show?: boolean;
  hide?: boolean;
}

export default function Barrier({ children, when, show, hide }: Props) {
  const { userCan, userCannot } = useRoles();

  if (userCan(when) && hide) return null;
  if (userCannot(when) && show) return null;

  return children;
}
